<script setup>
import { ref } from 'vue'

const props = defineProps({
    pages: Object,
})

const translateLabel = (label) => {
    const translations = {
        '&laquo; Previous': '&laquo; Předchozí',
        'Next &raquo;': 'Další &raquo;',
    }
    return translations[label] ? translations[label] : label
}
</script>

<template>
    <div class="mt-20">
        <div class="flex justify-center">
            <component
                v-for="link in pages.links"
                :is="link.url ? 'Link' : 'span'"
                :href="link.url"
                :key="link.id"
                v-html="translateLabel(link.label)"
                class="faster-animation mx-1 rounded-md bg-zinc-200 px-4 py-2 text-zinc-800 hover:bg-red-600 hover:text-white"
                :class="{
                    'cursor-not-allowed': !link.url,
                    '!bg-red-600 !text-white': link.active,
                }"
            />
        </div>
    </div>
</template>
